import React, { useState, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import BotonUser2 from "../userBotones/BotonUser2";
import logohome from "../assets/imagenes/fans/logo-menu.png";

const Navigation = React.memo(() => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = useCallback(() => {
    setMenuOpen(prev => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    setMenuOpen(false);
  }, []);

  // Memoizar los enlaces de navegación
  const navigationLinks = useMemo(() => [
    { to: "/", id: "Inicio", label: "Inicio" },
    { to: "/ciudad/ASUNCION", id: "asuncion", label: "Asunción" },
    { to: "/ciudad/LAMBARE", id: "lambare", label: "Lambare" },
    { to: "/ciudad/LUQUE", id: "luque", label: "Luque" },
    { to: "/ciudad/SAN LORENZO", id: "sanlorenzo", label: "San Lorenzo" },
    { to: "/ciudad/ENCARNACION", id: "encarnacion", label: "Encarnacion" },
    { to: "/ciudad/C.D.E", id: "cde", label: "C.D.E" },
    { to: "/ciudad/FERNANDO DE LA MORA", id: "fdm", label: "Fernado de la Mora" },
  ], []);

  // Renderizado memoizado de enlaces
  const renderedLinks = useMemo(() => {
    return navigationLinks.map(link => (
      <Link 
        key={link.id}
        to={link.to} 
        onClick={closeMenu} 
        id={link.id} 
        className="lista-sidebar-n"
      >
        {link.label}
      </Link>
    ));
  }, [navigationLinks, closeMenu]);

  return (
    <Navbar collapseOnSelect expand="lg" bg="#13141f" variant="dark">
      <Container>
        <Navbar.Brand>
          <Link to="/">
            <img 
              src={logohome} 
              className="icon-logo" 
              alt="SÓLO FÁNATICOS" 
              loading="lazy"
            />
          </Link>
        </Navbar.Brand>
        <div className="menu">
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={handleMenuToggle}
          />
        </div>
        <Navbar.Collapse id="responsive-navbar-nav" in={isMenuOpen}>
          <Nav className="me-auto">
            {renderedLinks}
          </Nav>
          <Nav>
            {/* Espacio para enlaces adicionales si se necesitan */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
});

Navigation.displayName = 'Navigation';

export default Navigation;
